import React from 'react';
import ListItemSecondaryActionBase from '@material-ui/core/ListItemSecondaryAction';

const ListItemSecondaryAction = (props) => (
  <ListItemSecondaryActionBase {...props} />
);

export default ListItemSecondaryAction;
